// 0 = lunes ... 6 = domingo (igual que date.weekday() en el backend)
export const WEEKDAYS = [
  { value: 0, short: 'Lun', long: 'Lunes', plural: 'lunes' },
  { value: 1, short: 'Mar', long: 'Martes', plural: 'martes' },
  { value: 2, short: 'Mié', long: 'Miércoles', plural: 'miércoles' },
  { value: 3, short: 'Jue', long: 'Jueves', plural: 'jueves' },
  { value: 4, short: 'Vie', long: 'Viernes', plural: 'viernes' },
  { value: 5, short: 'Sáb', long: 'Sábado', plural: 'sábados' },
  { value: 6, short: 'Dom', long: 'Domingo', plural: 'domingos' },
];

export const fmtDate = (iso) => {
  if (!iso) return '';
  const [y, m, d] = String(iso).slice(0, 10).split('-');
  return `${d}/${m}/${y}`;
};

// Una celda de la matriz por día de la semana es una regla permanente de un solo día, sin fechas.
export const isWeekdayCellRule = (rule) =>
  !rule.date_from && !rule.date_to && Array.isArray(rule.weekdays) && rule.weekdays.length === 1;

export const describeRule = (rule) => {
  const days = (rule.weekdays || [])
    .map((d) => WEEKDAYS.find((w) => w.value === d)?.plural)
    .filter(Boolean)
    .join(', ');

  if (rule.date_from && rule.date_from === rule.date_to) return fmtDate(rule.date_from);

  const range = rule.date_from && rule.date_to
    ? `${fmtDate(rule.date_from)} al ${fmtDate(rule.date_to)}`
    : rule.date_from
      ? `Desde el ${fmtDate(rule.date_from)}`
      : rule.date_to
        ? `Hasta el ${fmtDate(rule.date_to)}`
        : '';

  if (range && days) return `Los ${days} · ${range}`;
  if (range) return range;
  return `Todos los ${days}`;
};

export const errorMessage = (error, fallback) =>
  error?.response?.data?.error || error?.response?.data?.message || fallback;

// Une dos rangos de fechas ISO a recalcular; `date_to` null = sin fecha de fin.
export const mergeRecalcRanges = (a, b) => {
  if (!a) return b || null;
  if (!b) return a;
  return {
    date_from: a.date_from < b.date_from ? a.date_from : b.date_from,
    date_to: a.date_to === null || b.date_to === null ? null : (a.date_to > b.date_to ? a.date_to : b.date_to),
  };
};

export const describeRecalcRange = (range) => {
  if (!range) return '';
  return range.date_to
    ? (range.date_to === range.date_from ? fmtDate(range.date_from) : `${fmtDate(range.date_from)} al ${fmtDate(range.date_to)}`)
    : `desde el ${fmtDate(range.date_from)} en adelante`;
};
